module.exports = __webpack_public_path__ + "img/IAR9.64500630.png";